'use strict';

module.exports = spr2;

function spr2 () {
  console.error('SPR (symmetric packed rank 2 operation A := alpha*x*y\' + alpha*y*x\' + A) not yet implemented');
}
